import Joi from 'joi';
export const UserSchema = Joi.object({
  _id: Joi.string(),
  displayName: Joi.string().required(),
  email: Joi.string().required(),
  permissions: Joi.array().required(),
  photoURL: Joi.string(),
  uid: Joi.string(),
});
